import React, { useMemo, useState } from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { NowCompactProductCard } from './NowCompactProductCard';
type DealCategory = 'All' | 'Health' | 'Baby' | 'Vitamins';
type DealProduct = {
  id: number;
  name: string;
  brand?: string;
  price: number;
  originalPrice?: number;
  discount?: number;
  image: string;
  dealCategory: Exclude<DealCategory, 'All'>;
};
interface NowTopDealsProps {
  products: DealProduct[];
}
const dealCategories: {
  label: DealCategory;
  category: DealCategory;
}[] = [{
  label: 'All',
  category: 'All'
}, {
  label: 'Health',
  category: 'Health'
}, {
  label: 'Vitamins',
  category: 'Vitamins'
}, {
  label: 'Baby',
  category: 'Baby'
}];
export function NowTopDeals({
  products
}: NowTopDealsProps) {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState<DealCategory>('All');
  const visibleProducts = useMemo(() => {
    if (activeCategory === 'All') return products.slice(0, 6);
    return products.filter(product => product.dealCategory === activeCategory).slice(0, 6);
  }, [activeCategory, products]);
  return <section aria-labelledby="top-deals-heading" data-id="element-4329" data-mp="27sgtk2zoth3u">
      <div className="mb-4 flex items-end justify-between gap-4" data-id="element-4330" data-mp="22yuey59yr35e">
        <div data-id="element-4331" data-mp="1y0ki7q8lbuho">
          <h2 id="top-deals-heading" className="text-xl font-bold tracking-tight text-brand-ink md:text-2xl" data-id="element-4332" data-mp="1y0stjdp2erqr">Top deals</h2>
          <p className="mt-1 text-sm text-brand-muted" data-id="element-4333" data-mp="1t2izx7iznz79">Up to 35% off selected essentials.</p>
        </div>
        <button type="button" onClick={() => navigate('/offers?from=now')} className="inline-flex shrink-0 items-center gap-1 text-sm font-bold text-brand transition-colors duration-150 hover:text-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-4334" data-mp="1o1bpt1tdinxf">
          View all <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-4335" data-mp="3edrgufr8xmu6" />
        </button>
      </div>
      <div className="mb-4 flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="tablist" aria-label="Top deal categories" data-id="element-4336" data-mp="39fg49x9kgy89">
        {dealCategories.map(({
        label,
        category
      }) => <button key={category} type="button" role="tab" aria-selected={activeCategory === category} onClick={() => setActiveCategory(category)} className={`shrink-0 rounded-full px-3 py-2 text-sm font-bold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand ${activeCategory === category ? 'bg-brand text-white' : 'border border-brand-border bg-white text-brand-ink hover:bg-brand-light'}`} data-id="element-4337" data-mp="16gkte8aos5r">
            {label}
          </button>)}
      </div>
      <div className="grid grid-flow-col grid-rows-1 auto-cols-[calc((100%_-_16px)_/_3)] gap-2 overflow-x-auto pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:auto-cols-[185px] md:gap-3" data-id="element-4338" data-mp="b2rya7jmfo1s">
        {visibleProducts.map(product => <NowCompactProductCard key={product.id} product={product} data-id="element-4339" data-mp="2vrzb17aze1en" />)}
      </div>
    </section>;
}